import { Component, Inject, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { FEATURE_FLAG_SERVICE, CloudFeatureFlagsService } from '@shure/cloud/shared/utils/feature-flags';

@Component({
	selector: 'sh-my-account-side-nav',
	templateUrl: './my-account-side-nav.component.html',
	styleUrls: ['./my-account-side-nav.component.scss']
})
export class MyAccountSideNavComponent {
	@Input() public navigateTo!: string;
	public showSideNavItem = false;
	public isMotivSubscriptionsEnable$ = this.checkMotiveSubscriptionsEnable();
	constructor(@Inject(FEATURE_FLAG_SERVICE) private readonly featureFlagsService: CloudFeatureFlagsService) {}

	/**
	 * check motive-subscription feature flag enable/disable.
	 *
	 * @returns - returns Observable of boolean.
	 */
	public checkMotiveSubscriptionsEnable(): Observable<boolean> {
		return this.featureFlagsService.getFeatureFlag$('shure-cloud-motiv-subscriptions-enabled');
	}
}
